import TermItemSelect, { TermItemSelectTemplateItem } from './TermItemSelect';
import React from 'react';
import { useFormContainerContext } from '../../../Services/FormContainerContext';
import { FieldError, useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../Components/Form/components/TopFieldContent';
import ErrorMessage from '../../../Components/Form/components/ErrorMessage';

interface Props {
	name: string;
	label?: string;
	isRequired?: boolean;
	termType: string;
	error?: FieldError;
	useValue?: boolean;
	placeholder?: string;
	ItemTemplate?: (item: TermItemSelectTemplateItem) => React.ReactElement;
	isWrapped?: boolean;
}

const TermItemSelectField: React.FC<Props> = ({
	name,
	label,
	isRequired,
	termType,
	error: err,
	useValue = false,
	placeholder,
	ItemTemplate,
	isWrapped,
}) => {
	const { name: formContainerName } = useFormContainerContext();
	const finalName = formContainerName ? `${formContainerName}.${name}` : name;

	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: finalName || '',
	});

	const component = (
		<>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<TermItemSelect
				termType={termType}
				error={err}
				useValue={useValue}
				placeholder={placeholder}
				ItemTemplate={ItemTemplate}
				{...field}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</>
	);

	if (isWrapped) {
		return component;
	}

	return component;
};

export default TermItemSelectField;
